import React, { useEffect, useState } from "react";
import axios from "axios";
import { UserConsumer } from "../../../UserContext";
import { ReimbursementAPIs } from "../../MyReimbursement/MyReimbursementAPI's";
import ReimbursementPolicyTable from "./ReimbursementPolicyTable";
import ReimbursementPolicyForm from "./ReimbursementsPolicyForm";
import { AlertPopups } from "../../../components/AlertPopups";
import Header from "../../timesheetModule/Header";
import { dateCol } from "../../ticketModule/variables/ListingVariables";
import { Redirect } from "react-router-dom";
import moment from "moment";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";

const ReimbursementPolicy = () => {
	let token = null;
	const defaultSorted = [
		{
			dataField: "code",
			order: "desc",
		},
	];
	const [designationList, setDesignationList] = useState();
	const [getDesignationID, setDesignationID] = useState(null);
	const [tableData, setTableData] = useState([]);
	const [pagerData, setPagerData] = useState(null);
	const [pageNum, setPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(10);
	const [wefDate, setWefDate] = useState(new Date());
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [formFields, setFormFields] = useState({
		medical: 0,
		medicalParent: 0,
		medicalDental: 0,
		internet: 0,
		fuel: 0,
		mobile: 0,
		healthClub: 0,
		wefDate: wefDate,
	});
	useEffect(() => {
		getDesignationList();
	}, []);

	const getColumns = [
		{
			dataField: "medicalMaximum",
			text: "Medical (Min)",
		},
		{
			dataField: "medicalParents",
			text: "Medical (Parents)",
		},
		{
			dataField: "medicalDental",
			text: "Medical (Dental)",
		},
		{
			dataField: "internet",
			text: "Internet",
		},
		{
			dataField: "fuel",
			text: "Fuel/Maintenance",
		},
		{
			dataField: "mobile",
			text: "Mobile",
		},
		{
			dataField: "healthClub",
			text: "Health Club",
		},
		{
			dataField: "wefDate",
			text: "WEF date",
			formatter: dateCol,
		},
	];
	const wefDateChange = (date) => {
		setWefDate(date);
	};
	const getDesignationList = () => {
		axios
			.get(`${ReimbursementAPIs.GetEmployeeDesignationList}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				setDesignationList(data.designations);
			});
	};
	const getObject = (obj) => {
		setDesignationID(obj.value);
		setIsLoading(true);
		axios
			.get(
				`${ReimbursementAPIs.GetPoliceisList}?DesignationId=${obj.value}&pageNumber=1&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then((res) => {
				setIsLoading(false);
				setTableData(res.data);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
			});
	};
	const handleChange = (e) => {
		setFormFields({ ...formFields, [e.target.name]: e.target.value });
	};
	const ResetForm = () => {
		setFormFields({
			medical: 0,
			medicalParent: 0,
			medicalDental: 0,
			internet: 0,
			fuel: 0,
			mobile: 0,
			healthClub: 0,
			wefDate: wefDate,
		});
	};
	const handleSubmit = () => {
		const body = {
			medicalMaximum: formFields.medical,
			medicalParents: formFields.medicalParent,
			medicalDental: formFields.medicalDental,
			internet: formFields.internet,
			fuel: formFields.fuel,
			mobile: formFields.mobile,
			healthClub: formFields.healthClub,
			wefDate: moment(wefDate).format(APIDateFormat),
		};
		if (getDesignationID) {
			setIsLoading(true);

			axios
				.post(
					`${ReimbursementAPIs.CreateNewPolices}/${getDesignationID}`,
					body,
					{ headers: { Authorization: `Bearer ${token}` } }
				)
				.then(({ data }) => {
					AlertPopups.successAlert.fire({
						text: "Success",
					});
					axios
						.get(
							`${ReimbursementAPIs.GetPoliceisList}?DesignationId=${getDesignationID}&pageNumber=1&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`,
							{ headers: { Authorization: `Bearer ${token}` } }
						)
						.then((res) => {
							setIsLoading(false);
							setTableData(res.data);
							setPagerData(
								JSON.parse(res.headers["x-pagination"])
							);
						});
					ResetForm();
				})
				.catch((err) => {
					if (err.response) {
						AlertPopups.ErrorAlert.fire({
							text: `${err.response.data.message}`,
						});
					}
				});
		} else {
			AlertPopups.ErrorAlert.fire({
				text: "Please Select Designation",
			});
		}
	};
	const receiveData = (PageSize) => {
		setIsLoading(true);
		axios
			.get(
				`${ReimbursementAPIs.GetPoliceisList}?DesignationId=${getDesignationID}&pageNumber=1&PageSize=${PageSize}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setTableData(res.data);
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
			apiURL = `${ReimbursementAPIs.GetPoliceisList}?DesignationId=${getDesignationID}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortField}_${sortOrder}`;
		} else if (type === "pagination") {
			getData = true;
			apiURL = `${ReimbursementAPIs.GetPoliceisList}?DesignationId=${getDesignationID}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		}

		if (getData) {
			axios
				.get(apiURL, { headers: { Authorization: `Bearer ${token}` } })
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setTableData(res.data);
					}
				});
		}
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("5") ? (
					<div className="pl-3 pr-3">
						<Header title="Reimbursement Policy" />
						<ReimbursementPolicyForm
							formFields={formFields}
							designationList={designationList}
							getObject={getObject}
							handleChange={handleChange}
							wefDateChange={wefDateChange}
							handleSubmit={handleSubmit}
							wefDate={wefDate}
							ResetForm={ResetForm}
						/>
						{getDesignationID && (
							<ReimbursementPolicyTable
								tableLoader={isLoading}
								pagerData={pagerData}
								tableData={tableData}
								numberOfItemsPerPage={numberOfItemsPerPage}
								pageNum={pageNum}
								getColumns={getColumns}
								defaultSorted={defaultSorted}
								sortBy={sortBy}
								isLoading={isLoading}
								handleTableChange={handleTableChange}
								receiveData={receiveData}
							/>
						)}
					</div>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default ReimbursementPolicy;
